/**
 * Analytics Service - Main Export
 * 
 * Centralized export for all analytics-related functionality
 */

// DO NOT export the service itself - it contains server-side Redis initialization
// Only export types and constants that can be safely used on client side

// Re-export types from funnel module
export * from '@/services/funnel';

// Analytics-specific constants
export const ANALYTICS_ENDPOINTS = {
  SESSION: '/api/analytics/session',
  TRACK: '/api/analytics/track',
  FUNNELS_INIT: '/api/funnels/init'
} as const;

// Event tracking helpers
export const TRACKING_EVENTS = {
  STEP_ENTER: 'step_enter',
  STEP_COMPLETE: 'step_complete',
  STEP_EXIT: 'step_exit',
  INTERACTION: 'interaction',
  CONVERSION: 'conversion',
  DROPOUT: 'dropout'
} as const;

// Municipality funnel steps
export const MUNICIPALITY_STEPS = {
  LANDING: 'landing',
  ANALYSIS_VIEW: 'analysis_view',
  SCENARIO_INTERACTION: 'scenario_interaction',
  PARAMETER_ADJUSTMENT: 'parameter_adjustment',
  CALLBACK_REQUEST: 'callback_request'
} as const;

// Social media funnel steps
export const SOCIAL_MEDIA_STEPS = {
  AD_CLICK: 'ad_click',
  LANDING_PAGE: 'landing_page',
  MUNICIPALITY_SELECTION: 'municipality_selection',
  ANALYSIS_ENGAGEMENT: 'analysis_engagement',
  LEAD_GENERATION: 'lead_generation'
} as const;

// Email funnel steps
export const EMAIL_STEPS = {
  EMAIL_OPEN: 'email_open',
  LINK_CLICK: 'link_click',
  CONTENT_ENGAGEMENT: 'content_engagement',
  ACTION_TAKEN: 'action_taken'
} as const;

// Common interaction actions
export const INTERACTION_ACTIONS = {
  SCENARIO_CHANGE: 'scenario_change',
  PARAMETER_CHANGE: 'parameter_change',
  BUTTON_CLICK: 'button_click',
  FORM_SUBMIT: 'form_submit',
  SCROLL_DEPTH: 'scroll_depth'
} as const;

// Conversion types
export const CONVERSION_TYPES = {
  CALLBACK: 'callback',
  LEAD: 'lead',
  SIGNUP: 'signup',
  CONTACT: 'contact'
} as const;